/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const cs_attributes_size = /** @type {(inputs: {}) => string} */ () => {
	return `Velikost`
};

const da_attributes_size = /** @type {(inputs: {}) => string} */ () => {
	return `Størrelse`
};

const de_attributes_size = /** @type {(inputs: {}) => string} */ () => {
	return `Größe`
};

const en_attributes_size = /** @type {(inputs: {}) => string} */ () => {
	return `Size`
};

const es_attributes_size = /** @type {(inputs: {}) => string} */ () => {
	return `Talla`
};

const fr_attributes_size = /** @type {(inputs: {}) => string} */ () => {
	return `Taille`
};

const hu_attributes_size = /** @type {(inputs: {}) => string} */ () => {
	return `Méret`
};

const it_attributes_size = /** @type {(inputs: {}) => string} */ () => {
	return `Dimensione`
};

const nl_attributes_size = /** @type {(inputs: {}) => string} */ () => {
	return `Maat`
};

const pl_attributes_size = /** @type {(inputs: {}) => string} */ () => {
	return `Rozmiar`
};

const pt_attributes_size = /** @type {(inputs: {}) => string} */ () => {
	return `Tamanho`
};

const sv_attributes_size = /** @type {(inputs: {}) => string} */ () => {
	return `Storlek`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "cs" | "da" | "de" | "en" | "es" | "fr" | "hu" | "it" | "nl" | "pl" | "pt" | "sv" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
const attributes_size = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.attributes_size(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("attributes_size", locale)
	if (locale === "cs") return cs_attributes_size(inputs)
	if (locale === "da") return da_attributes_size(inputs)
	if (locale === "de") return de_attributes_size(inputs)
	if (locale === "en") return en_attributes_size(inputs)
	if (locale === "es") return es_attributes_size(inputs)
	if (locale === "fr") return fr_attributes_size(inputs)
	if (locale === "hu") return hu_attributes_size(inputs)
	if (locale === "it") return it_attributes_size(inputs)
	if (locale === "nl") return nl_attributes_size(inputs)
	if (locale === "pl") return pl_attributes_size(inputs)
	if (locale === "pt") return pt_attributes_size(inputs)
	return sv_attributes_size(inputs)
};
export { attributes_size as "attributes.size" }